import { XCircle } from "lucide-react";
import React from "react";
import { ReduxUpdater } from "../../../redux/ReduxUpdater";

const OffCanvas: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div 
            className="fixed h-[100vh] w-[500px] top-0 right-0"
        >
            {children}
            <XCircle
                className="clickable fixed top-3 right-3 text-red-600 z-50"
                onClick={() => ReduxUpdater.offCanvas = null}
            />
        </div>
    );
};

export default OffCanvas;